import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComboSexoComponent } from './combo-sexo.component';
import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { ComboPesquisavelModule } from '../combo-pesquisavel/combo-pesquisavel.module';



@NgModule({
  declarations: [ComboSexoComponent],
  imports: [
    CommonModule,
    MaterialCommonModule,
    MatExpansionModule,
    ComboPesquisavelModule
  ],
  exports:[ComboSexoComponent]
})
export class ComboSexoModule { }
